import styled from 'styled-components'
import { colors } from 'client/styles'

export const ConfirmationErrorBase = styled.div``

export const Row = styled.div`
  display: flex;
  width: 100%;

  padding-block: 10px;
  padding-inline: 0;
`

export const Title = styled(Row)`
  color: ${colors.red};
  display: flex;

  font-weight: 700;
  font-size: 21px;
  line-height: 130%;

  svg {
    fill: ${colors.red};
    padding-block-start: 2px 8px 0 8px;
  }
`

export const Subtitle = styled(Row)`
  color: ${colors.grey2};
  font-size: 16px;
  line-height: 150%;
`

export const Content = styled.div`
  padding-block: 10px;
  padding-inline: 20px;
`

export const ButtonWrapper = styled.div`
  padding-block: 20px;
  padding-inline: 20px;
`
